import { SalesMetrics } from "components/organisms/SalesMetricsIFrame";

const Metrics = () => {
  return <SalesMetrics />;
};

export { Metrics };
